// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iul input {
  font-size: 2.6rem;
}

.labelore {
  font-size: x-large;
  margin-top: -10px;
  margin-bottom: 12px;
}

.labeldataora {
  font-size: x-large;
  overflow: visible;
}

.divmovistantechiusura {
  font-size: medium;
  color: var(--color-primary);
  margin-bottom: 10px;
  border-bottom-color: lightgray;
  border-bottom-style: solid;
  border-bottom-width: thin;
  padding-bottom: 10px;
}

.colminutiaggiuntivi {
  margin-top: 4px;
  margin-left: 10px;
  font-size: medium;
  color: var(--color-primary);
  margin-bottom: 10px;
  border-bottom-color: lightgray;
  border-bottom-style: solid;
  border-bottom-width: thin;
  padding-bottom: 10px;
}

.labelattivitareale {
  font-size: x-large;
  margin-top: -10px;
  margin-bottom: 10px;
}

.labelnote {
  font-size: x-large;
}

.divradiominuti {
  float: left;
  padding-top: 10px;
  padding-left: 10px;
}

.labelradiominuti {
  vertical-align: super;
  color: var(--color-primary);
}

.labelminuti {
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
}

.footer {
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.radiomodlezione {
  vertical-align: text-bottom;
  margin-right: 2px;
}

.labelradiomodlezione {
  color: var(--color-primary);
}

.override-backdrop {
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ril-viewer/modifica-rilevazione/modifica-rilevazione.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yBAAA;EACA,oBAAA;AACJ;;AAIA;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,qBAAA;EACA,2BAAA;AADJ;;AAIA;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AADJ;;AAIA;EACI,2BAAA;EACA,iBAAA;AADJ;;AAIA;EACI,2BAAA;AADJ;;AAGA;EACI,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;AAAJ","sourcesContent":[".iul input {\n    font-size: 2.6rem;\n    }\n\n.labelore {\n    font-size: x-large;\n    margin-top: -10px;\n    margin-bottom: 12px;\n}\n\n.labeldataora {\n    font-size: x-large;\n    overflow: visible;\n}\n\n.divmovistantechiusura {\n    font-size: medium;\n    color: var(--color-primary);\n    margin-bottom: 10px;\n    border-bottom-color: lightgray;\n    border-bottom-style: solid;\n    border-bottom-width: thin;\n    padding-bottom: 10px;\n}\n\n.colminutiaggiuntivi {\n    margin-top: 4px; \n    margin-left: 10px;\n    font-size: medium;\n    color: var(--color-primary);\n    margin-bottom: 10px;\n    border-bottom-color: lightgray;\n    border-bottom-style: solid;\n    border-bottom-width: thin;\n    padding-bottom: 10px;\n\n}\n\n\n.labelattivitareale {\n    font-size: x-large;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}\n\n.labelnote {\n    font-size: x-large;\n}\n\n.divradiominuti {\n    float:left; \n    padding-top: 10px;\n    padding-left: 10px;\n}\n\n.labelradiominuti {\n    vertical-align: super;\n    color: var(--color-primary);\n}\n\n.labelminuti {\n    font-size: large;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.footer {\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n}\n\n.radiomodlezione {\n    vertical-align: text-bottom;\n    margin-right: 2px;\n}\n\n.labelradiomodlezione {\n    color: var(--color-primary);\n}\n.override-backdrop {\n    background-color: rgba(0, 0, 0, 0.2);\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
